module.exports = __webpack_public_path__ + "media/images/lb/149-57c93c2369348f56b50e81399e9f4831.svg";